class ColourChartList extends HTMLElement {
  connectedCallback() {
    this._abort = new AbortController();
    const signal = this._abort.signal;
    const BATCH_SIZE = 8;

    const links = this.querySelector('.links-list');
    const loadMoreBtn = this.querySelector('.shade-load-more');
    const firstRadio = this.querySelector('input[type="radio"][name^="categories-"]');
    if (!links || !firstRadio) return;

    const radioGroupName = firstRadio.name;

    const getGroupCards = (handle) =>
      Array.from(links.querySelectorAll(`li[data-group="${handle}"]`));

    const getActiveGroup = () => {
      const checked = this.querySelector(`input[name="${radioGroupName}"]:checked`);
      return checked ? checked.value : null;
    };

    const updateLoadMore = (handle) => {
      if (!loadMoreBtn) return;
      const hasMore = getGroupCards(handle).some((c) => c.classList.contains('hidden'));
      loadMoreBtn.style.display = hasMore ? '' : 'none';
    };

    const showGroup = (handle) => {
      links.querySelectorAll('li').forEach((c) => c.classList.add('hidden'));
      getGroupCards(handle).slice(0, BATCH_SIZE).forEach((c) => c.classList.remove('hidden'));
      updateLoadMore(handle);
    };

    const loadMore = (handle) => {
      getGroupCards(handle)
        .filter((c) => c.classList.contains('hidden'))
        .slice(0, BATCH_SIZE)
        .forEach((c) => c.classList.remove('hidden'));
      updateLoadMore(handle);
    };

    const defaultGroup = getActiveGroup();
    if (defaultGroup) updateLoadMore(defaultGroup);

    this.querySelectorAll(`input[name="${radioGroupName}"]`).forEach((radio) => {
      radio.addEventListener('change', () => showGroup(radio.value), { signal });
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener(
        'click',
        () => {
          const group = getActiveGroup();
          if (group) loadMore(group);
        },
        { signal }
      );
    }
  }

  disconnectedCallback() {
    this._abort?.abort();
  }
}

if (!customElements.get('colour-chart-list')) {
  customElements.define('colour-chart-list', ColourChartList);
}
